module.exports = __webpack_public_path__ + "img/follower.b4728f43.png";